/**
 * 마일스톤 팝업 관련 유틸리티 함수
 */

import { MilestoneType } from "../components/MilestonePopup";

const SHOWN_MILESTONES_KEY = "shown_milestones";

// 마일스톤 목록
export const MILESTONES: (50 | 100 | 200)[] = [50, 100, 200];

/**
 * 이미 표시한 마일스톤 목록 조회
 */
export function getShownMilestones(): MilestoneType[] {
  if (typeof window === "undefined") return [];

  try {
    const stored = localStorage.getItem(SHOWN_MILESTONES_KEY);
    if (!stored) return [];
    return JSON.parse(stored) as MilestoneType[];
  } catch {
    return [];
  }
}

/**
 * 마일스톤을 표시했음을 저장
 */
export function markMilestoneAsShown(milestone: MilestoneType): void {
  if (typeof window === "undefined") return;

  try {
    const shown = getShownMilestones();
    if (!shown.includes(milestone)) {
      shown.push(milestone);
      localStorage.setItem(SHOWN_MILESTONES_KEY, JSON.stringify(shown));
    }
  } catch {
    // localStorage 오류 무시
  }
}

/**
 * 특정 마일스톤을 이미 표시했는지 확인
 */
export function hasMilestoneBeenShown(milestone: MilestoneType): boolean {
  const shown = getShownMilestones();
  return shown.includes(milestone);
}

/**
 * 이번 첫 풀이로 새로 달성한 마일스톤 확인
 *
 * 첫 풀이 1건은 푼 문제 수를 정확히 1 올리므로, 풀이 수가 마일스톤과 같아진 순간만
 * "이번에 달성한" 것으로 본다. 표시 기록(localStorage)이 지워진 브라우저에서도
 * 이미 지나간 마일스톤(예: 150문제 시점의 100·50)을 다시 띄우지 않는다 (JCG-3864).
 * @param solvedCount 이번 풀이를 포함해 현재까지 푼 문제 수
 * @param totalProblems 전체 문제 수 (전체 완료 마일스톤 체크용)
 * @returns 새로 달성한 마일스톤 (없으면 null)
 */
export function checkNewMilestone(
  solvedCount: number,
  totalProblems?: number
): MilestoneType | null {
  // 전체 문제 완료 체크 (가장 높은 마일스톤)
  if (totalProblems && solvedCount === totalProblems && !hasMilestoneBeenShown("all")) {
    return "all";
  }

  const milestone = MILESTONES.find((m) => m === solvedCount);
  if (milestone && !hasMilestoneBeenShown(milestone)) {
    return milestone;
  }

  return null;
}

/**
 * 모든 마일스톤 기록 초기화 (디버그/테스트용)
 */
export function resetMilestones(): void {
  if (typeof window === "undefined") return;
  localStorage.removeItem(SHOWN_MILESTONES_KEY);
}
